export function findParentDialog(startNode, className) {
  var current = startNode;
  while (current) {
    if (current.classList.contains(className || "shp--app-dialog")) {
      return current;
    }
    current = current.parentElement;
  }
  return undefined;
}